import { createApp } from 'vue'
import { ElButton, ElSelect, ElHeader, ElMain, ElTag, ElRadio, ElRadioGroup, ElRow, ElMessage, ElIcon,
ElCheckbox, ElCheckboxGroup, ElDialog, ElLoading, ElForm, ElFormItem, ElInput, ElOption, ElImage,
ElCascader } from 'element-plus';
import App from './App.vue';

import 'element-plus/lib/theme-chalk/base.css';
import { ElCollapseTransition } from 'element-plus';

import router from './router'

const app = createApp(App)

var option = { size: 'small', zIndex: 3000 };
app.config.globalProperties.$ELEMENT = option;

app.use(router)
app.use(ElButton).use(ElSelect).use(ElHeader).use(ElMain).use(ElTag).use(ElRadio).use(ElRadioGroup).use(ElRow).use(ElMessage).use(ElIcon)
.use(ElCheckbox).use(ElCheckboxGroup).use(ElDialog).use(ElLoading).use(ElForm).use(ElFormItem).use(ElInput).use(ElOption).use(ElImage)
.use(ElCascader)

app.component(ElCollapseTransition.name, ElCollapseTransition)

app.mount('#app')